<form [formGroup]="formPresenca" (ngSubmit)="enviarConfirmacao($event)">
  <div class="info">
    <h1>RSVP</h1>
    <h1>Débora & João Pedro</h1>
    <p class="line">____________________________________</p>
    <h2>Detalhes</h2>
    <p>Domingo, 14 de Novembro, 2021</p>
    <p>2:30 PM</p>
    <br />
    <h2>Cerimonia & Recepção</h2>
    <p>Espaço la forêt</p>
    <p><a href="https://goo.gl/maps/fVq8p29sLrr3bbvn9">Estr. do Sacramento, 18 - Alto do Sabiá, São Roque - SP, 18130-970</a></p>
    <p class="line">____________________________________</p>
    <div *ngIf="loading;then loading_animation else no_loading"></div>
    <ng-template #no_loading>
      <div *ngIf="mensagemText;then mensagem else form_presenca"></div>
    </ng-template>
    <ng-template #mensagem>
      <h1>{{mensagemText}}</h1>
    </ng-template>
    <ng-template #form_presenca>
      <input type="text" formControlName="nome" placeholder="Nome" />
      <p class="error-message" *ngIf="error && formPresenca.controls.nome.invalid">*Nome obrigatório</p>
      <div class="checkbox">
        <input type="checkbox" formControlName="familia" id="check" />
        <label class="label-check" for="check">
          <svg viewBox="0,0,50,50">
            <path d="M5 30 L 20 45 L 45 5"></path>
          </svg>
        </label>
        <label for="check">&nbsp; e familia</label>
      </div>
    </ng-template>
    <ng-template #loading_animation>
      <app-loading></app-loading>
    </ng-template>
    
  </div>
  <button class="accept" [disabled]="disabledButtons">Confirmo</button>
  <button class="regret" [disabled]="disabledButtons">Não poderei ir</button>
</form>
